var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"error--text"},_vm._l((_vm.data.errors),function(values,key){return _c('li',{key:key},[_c('strong',[_vm._v(_vm._s(key))]),_c('ul',_vm._l((values),function(val){return _c('li',{key:`${key}-${val}`},[_vm._v(_vm._s(val))])}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }